import type { VerifiedFinding } from '../../lib/types';
import { isLimitedEvidence } from '../../lib/insightClient';
import { withDisplayNames } from '../../lib/foodDisplayName';
import { InsetGroup, SectionHeader } from './insightsUi';

export interface PatternListProps {
  /** Verified findings already filtered to engine candidates (see filterShownFindings). */
  findings: VerifiedFinding[];
}

/** "Patterns the AI spotted": verified combination and pattern findings with recounted numbers. */
export function PatternList({ findings }: PatternListProps) {
  const shown = findings.filter((f) => f.kind === 'combination' || f.kind === 'pattern');
  if (shown.length === 0) return null;

  return (
    <section>
      <SectionHeader>Patterns the AI spotted</SectionHeader>
      <InsetGroup>
        {shown.map((f, i) => (
          <div key={`${f.title}-${i}`} className="px-4 py-3">
            <div className="text-base text-slate-950 dark:text-white">{withDisplayNames(f.title, f.items)}</div>
            <div className="text-[0.8125rem] leading-snug text-slate-500 dark:text-zinc-400">
              {f.displayText} · verified
            </div>
            {isLimitedEvidence(f) && (
              <div className="mt-0.5 text-xs text-amber-700 dark:text-amber-300">Limited evidence</div>
            )}
          </div>
        ))}
      </InsetGroup>
    </section>
  );
}
